import { PdfGen } from '../pdf/pdf';
import { OptsMulti } from './optsMulti';

export const ILayoutMultiSymbol = Symbol('LayoutMulti');

export interface ILayoutMultiGen {
  generate(pdf: PdfGen, opts: OptsMulti): Promise<void>;
}
